import { Input } from "@gocardless/flux-react";
import { ComponentPropsWithoutRef, forwardRef } from "react";

export const OneTimePasswordInput = forwardRef<
  HTMLInputElement,
  ComponentPropsWithoutRef<typeof Input>
>(({ ...rest }, ref) => (
  <Input
    type="text"
    autoComplete="off"
    inputMode="numeric"
    style={{
      letterSpacing: "14px",
      textAlign: "center",
      fontSize: "28px",
    }}
    ref={ref}
    {...rest}
  />
));
